import apiRoutes from '@constants/apiRoutes';
import baseApi from '@services/api';

const user = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserDetails: builder.query<any, any>({
      query: (id) => `account${apiRoutes.getUserDetails}/${id}/`
    })
  })
});

export const { useLazyGetUserDetailsQuery } = user;
